export const NS = 'translation';
